/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import { ElementNode, } from 'lexical';
export function convertCollapsibleContentElement() {
    const node = $createCollapsibleContentNode();
    return {
        node,
    };
}
export class CollapsibleContentNode extends ElementNode {
    static getType() {
        return 'collapsible-content';
    }
    static clone(node) {
        return new CollapsibleContentNode(node.__key);
    }
    createDOM(_config) {
        const dom = document.createElement('div');
        dom.classList.add('Collapsible__content');
        return dom;
    }
    updateDOM(_prevNode, _dom) {
        return false;
    }
    static importDOM() {
        return {
            div: (domNode) => {
                if (!domNode.hasAttribute('data-lexical-collapsible-content')) {
                    return null;
                }
                return {
                    conversion: convertCollapsibleContentElement,
                    priority: 2,
                };
            },
        };
    }
    static importJSON(_serializedNode) {
        return $createCollapsibleContentNode();
    }
    isShadowRoot() {
        return true;
    }
    exportDOM() {
        const element = document.createElement('div');
        element.setAttribute('data-lexical-collapsible-content', 'true');
        return { element };
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: 'collapsible-content',
            version: 1,
        };
    }
}
export function $createCollapsibleContentNode() {
    return new CollapsibleContentNode();
}
export function $isCollapsibleContentNode(node) {
    return node instanceof CollapsibleContentNode;
}
